/* Original name trustyle.button */

import { useThemeUI } from 'theme-ui'
import { darken } from '@theme-ui/color'
import { path } from '@uswitch/ev-utils/obj'

const invertTheme = (theme, variant = {}) => {
  const backgroundColor = variant.color
  const color = variant.backgroundColor || 'white'
  const borderColor = color
  const hoverColor = theme.colors[backgroundColor]
    ? darken(theme.colors[backgroundColor], 0.1)
    : null
  return {
    ...variant,
    backgroundColor,
    color,
    borderColor,
    borderWidth: 2,
    borderStyle: 'solid',
    '@media (hover: hover)': {
      // prevents sticky hover bug on iOS
      ':hover': {
        backgroundColor: hoverColor,
      },
      ':hover:not(:disabled)': {
        backgroundColor: hoverColor,
      },
    },
  }
}

export const Button = ({
  children,
  disabled = false,
  variant,
  iconPosition = null,
  onClick,
  size = 'large',
  inverse = false,
  ...props
}) => {
  const { theme } = useThemeUI()

  const variantStyle = path(`elements.buttons.variants.${variant}`.split('.'), theme)
  const chosenStyle = inverse ? invertTheme(theme, variantStyle) : variantStyle
  return (
    <button
      sx={{
        cursor: 'pointer',
        backgroundImage: 'none',
        fontFamily: 'base',
        fontSize: path(`elements.buttons.base.btnSize.${size}.fontSize`.split('.'), theme, 'base'),
        paddingX: path(`elements.buttons.base.btnSize.${size}.paddingX`.split('.'), theme, 'sm'),
        paddingY: path(`elements.buttons.base.btnSize.${size}.paddingY`.split('.'), theme, 'base'),
        variant: path(`elements.buttons.variants.${variant}`.split('.'), theme),
        justifyContent: 'center',
        alignItems: 'center',
        ...chosenStyle,
        ...(iconPosition
          ? {
              display: 'flex',
              justifyContent:
                iconPosition === 'left'
                  ? 'flex-start'
                  : iconPosition === 'right'
                  ? 'space-between'
                  : 'center',
            }
          : {}),
      }}
      disabled={disabled}
      type={onClick ? 'button' : 'submit'}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}
